import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Colorado = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Colorado Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Must disclose special taxing districts, common interest
          communities, and meth lab usage.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Property Disclosure: Required for residential sales.
        </Text>

        <Text style={styles.listItem}>
          3. A buyer of residential real property has the right to test the
          property for the purpose of determining whether the property has ever
          been used as a methamphetamine laboratory.
        </Text>

        <Text style={styles.listItem}>
          4. Inspection Objection: Buyers must submit objections within a
          specified timeframe.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Green Disclosure</Text> – For
          properties that contain or are equipped with energy-related features
          and technologies.
        </Text>

        <Text style={styles.listItem}>
          7. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          In accordance with the U.S. Consumer Product Safety Commission, the
          seller must provide this form to a potential buyer for properties
          built before 1978.
        </Text>

        <Text style={styles.listItem}>
          8. <Text style={styles.underline}>Radon Disclosure</Text> – Sellers
          must disclose any knowledge of radon concentrations and provide a
          warning on the dangers of radon to prospective buyers.
        </Text>

        <Text style={styles.listItem}>
          9. <Text style={styles.underline}>Seller's Property Disclosure</Text>{' '}
          – A comprehensive disclosure form covering state-mandated
          requirements, including taxing districts, common interest community,
          meth lab, potable water, transportation projects, and oil and gas
          activity.
        </Text>

        <Text style={styles.listItem}>
          10.{' '}
          <Text style={styles.underline}>
            Transportation Projects Disclosure
          </Text>{' '}
          – Sellers must disclose any nearby transportation projects in the
          property disclosure.
        </Text>
      </View>
    </View>
  );
};

export default Colorado;
